/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Starting_StatusInputs */



/**
* | output |
* | --- |
* | "Starting frame cache..." |
*
* @param {Pre_Render_Frame_Cache_Starting_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_starting_status = /** @type {((inputs?: Pre_Render_Frame_Cache_Starting_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Starting_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage du cache d'images...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Cache wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio della cache dei frame...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальный кэш кадров...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando caché de fotogramas...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始帧缓存...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームキャッシュを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम कैशिंग शुरू हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o cache de quadros...")
	return /** @type {LocalizedString} */ ("Starting frame cache...")
});